import Serializable from '@/core/misc/mixins/Serializable';
import Utils from '@/core/utils/Utils';
import SWCostscenter from '@/domains/SWCostscenters/SWCostscenter';

/**
 * Производственная площадка
 */
class ProductionSite extends Serializable {

    /* Идентификатор */
    public id: string;

    /* Наименование площадки */
    public name: string;

    /* ЦФО площадки (из oracle.sw_costscenters) */
    public swCostscenter: SWCostscenter | null;

    static fromServer(data: any, result = new ProductionSite()): ProductionSite {
        const site = super.fromServer(data, result);
        site.swCostscenter = Utils.hydrate(data.swCostscenter, SWCostscenter.fromServer);
        return site;
    }

    toString() { return this.name }
}

export default ProductionSite;
